/**
 * @see mockMd/union_city_war_pk_switch.md
 */
import {UnionCityWarActionStatus, type UnionCityWarPkSwitchData} from '../types'

export const UnionCityWarPkSwitchDisableMock: UnionCityWarPkSwitchData = {
  status: UnionCityWarActionStatus.Success,
  enable: false,
  err_msg: '即将关闭下一轮及后续PK',
}

export const UnionCityWarPkSwitchEnableMock: UnionCityWarPkSwitchData = {
  status: UnionCityWarActionStatus.Success,
  enable: true,
  err_msg: '',
}

export const UnionCityWarPkSwitchMock = UnionCityWarPkSwitchDisableMock
